import { ExperienceDto } from "@intelligems/ig-types/dtos/experiences";
import { ExperiencePageTargetingDto } from "@intelligems/ig-types/dtos/experience-page-targeting";
import { OrganizationDto } from "@intelligems/ig-types/dtos/organizations";
import { RedirectDto } from "@intelligems/ig-types/dtos/redirects";
import { getPreviewPathShared } from "@intelligems/ig-utils/get-preview-path";

export const getPreviewThemeId = (
  themeRedirects: RedirectDto[],
  variationId?: string
) => {
  if (themeRedirects.length === 0) {
    return "";
  }

  let themeRedirect = themeRedirects[0];
  if (variationId) {
    themeRedirect =
      themeRedirects.find((redirect) => redirect.variationId === variationId) ||
      themeRedirects[0];
  }
  return themeRedirect.queryParams.length &&
    themeRedirect.queryParams[0].value !== undefined
    ? themeRedirect.queryParams[0].value
    : "";
};

export const generatePreviewLink = ({
  organization,
  experience,
  previewThemeId,
  variationId,
  addSsTrafficDetails,
  customDevicePath,
  builderModeEntity,
  authToken,
  useOriginUrl,
  redirects,
  pageTargeting,
  isLive,
  extraParams,
}: {
  organization: OrganizationDto;
  experience: Pick<ExperienceDto, "devicePreview" | "previewPath"> & {
    id?: string;
  };
  variationId?: string;
  previewThemeId?: string;
  addSsTrafficDetails?: boolean;
  customDevicePath?: string;
  builderModeEntity?: string;
  authToken?: string | null;
  useOriginUrl?: boolean;
  redirects?: RedirectDto[];
  pageTargeting?: ExperiencePageTargetingDto[];
  isLive?: boolean;
  extraParams?: { key: string; value: string }[];
}) => {
  if (variationId !== undefined) {
    redirects = (redirects || []).filter((r) => r.variationId === variationId);
  }
  const redirectPreview = getPreviewPathShared(
    redirects || [],
    pageTargeting || [],
    useOriginUrl
  );
  let localPath = customDevicePath
    ? customDevicePath
    : experience.devicePreview?.path && experience.devicePreview.path !== "/"
      ? experience.devicePreview.path
      : (redirects && redirects.length) ||
          (pageTargeting && pageTargeting.length)
        ? redirectPreview
        : experience.previewPath;

  if (localPath) {
    localPath = localPath.replace(/^\/*/, "");
  }

  const params: Record<string, string> = {};
  if (isLive) {
    params["ig-live-preview"] = "true";
  } else if (experience.id) {
    params["ig-preview"] = experience.id;
  }
  if (variationId) {
    params["igTg"] = variationId;
  }

  if (addSsTrafficDetails) {
    params["ig-ss"] = "true";
    params["ig-preview-traffic"] = "true";
  }

  if (previewThemeId) {
    params["preview_theme_id"] = previewThemeId;
    params["pb"] = "0";
  }

  if (builderModeEntity && authToken) {
    params["ig-builder-mode"] = "builder";
    params["ig-builder-entity"] = builderModeEntity;
    params["ig-auth-token"] = authToken;
  }
  if (extraParams) {
    extraParams.forEach(({ key, value }) => (params[key] = value));
  }
  if (extraParams) {
    extraParams.forEach(({ key, value }) => (params[key] = value));
  }

  // Construct the full URL string
  let urlString: string;
  if (localPath?.includes("https://")) {
    // localPath is already a full URL
    urlString = localPath;
  } else {
    const baseUrl = organization.domain ?? organization.shopId;
    const httpsUrl = baseUrl?.startsWith("https://")
      ? baseUrl
      : `https://${baseUrl}`;
    urlString = `${httpsUrl}/${localPath || ""}`;
  }

  try {
    const url = new URL(urlString);
    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.append(key, value);
    });
    return url.href;
  } catch {
    return "";
  }
};
